import React, { Component } from 'react';
import __ from 'lodash';

class TblKonversiSkor extends Component {
    constructor(props) {
        super(props);
        this.state = {             
            dataLiterasi: [],
            dataNumerasi: [],
        }
    }

    componentDidMount() {
        if(!__.isEmpty(this.props.data)) { 
            this.props.data.map(val => {
                if(val.namaMataPelajaran.toUpperCase() == 'LITERASI' ){
                    this.setState({ dataLiterasi: val.kategories })                    
                }
                if(val.namaMataPelajaran.toUpperCase() == 'NUMERASI' ){
                    this.setState({ dataNumerasi: val.kategories })
                }
            })
        }
    }

    tbody() {
        let pikLiterasi = {}, dasarLiterasi = {}, cukupLiterasi = {}, mahirLiterasi = {};
        this.state.dataLiterasi.map(d => {
            if(d.kategori === 'Perlu Intervensi Khusus') pikLiterasi = d;
            if(d.kategori === 'Dasar') dasarLiterasi = d;
            if(d.kategori === 'Cakap') cukupLiterasi = d;
            if(d.kategori === 'Mahir') mahirLiterasi = d;
        })
        
        let pikNumerasi = {}, dasarNumerasi = {}, cukupNumerasi = {}, mahirNumerasi = {};
        this.state.dataNumerasi.map(d => {
            if(d.kategori === 'Perlu Intervensi Khusus') pikNumerasi = d;
            if(d.kategori === 'Dasar') dasarNumerasi = d;
            if(d.kategori === 'Cakap') cukupNumerasi = d;
            if(d.kategori === 'Mahir') mahirNumerasi = d;
        })  

        return(
            <tbody>
                <tr>
                    <td> Perlu Intervensi Khusus</td>
                    <td className="text-center">{pikLiterasi.rataRata}</td>
                    <td className="text-center">{pikLiterasi.skorMax}</td>
                    <td className="text-center">{pikLiterasi.skorMin}</td>
                    <td className="text-center">{pikNumerasi.rataRata}</td>
                    <td className="text-center">{pikNumerasi.skorMax}</td>
                    <td className="text-center">{pikNumerasi.skorMin}</td>
                </tr>
                <tr>
                    <td> Dasar</td>
                    <td className="text-center">{dasarLiterasi.rataRata}</td>
                    <td className="text-center">{dasarLiterasi.skorMax}</td>
                    <td className="text-center">{dasarLiterasi.skorMin}</td>
                    <td className="text-center">{dasarNumerasi.rataRata}</td>
                    <td className="text-center">{dasarNumerasi.skorMax}</td>
                    <td className="text-center">{dasarNumerasi.skorMin}</td>
                </tr>
                <tr>
                    <td> Cakap</td>
                    <td className="text-center">{cukupLiterasi.rataRata}</td>
                    <td className="text-center">{cukupLiterasi.skorMax}</td>
                    <td className="text-center">{cukupLiterasi.skorMin}</td>
                    <td className="text-center">{cukupNumerasi.rataRata}</td>
                    <td className="text-center">{cukupNumerasi.skorMax}</td>
                    <td className="text-center">{cukupNumerasi.skorMin}</td>
                </tr>
                <tr>
                    <td> Mahir</td>
                    <td className="text-center">{mahirLiterasi.rataRata}</td>
                    <td className="text-center">{mahirLiterasi.skorMax}</td>
                    <td className="text-center">{mahirLiterasi.skorMin}</td>
                    <td className="text-center">{mahirNumerasi.rataRata}</td>
                    <td className="text-center">{mahirNumerasi.skorMax}</td>
                    <td className="text-center">{mahirNumerasi.skorMin}</td>
                </tr>
            </tbody>
        )
    }

    render() {

        return(
            <table className="table-asm" width="100%" border="1">
                <thead>
                    <tr>
                        <th className="text-center" rowSpan="2">Level Kompetensi</th>  
                        <th className="text-center" colSpan="3">Literasi</th>
                        <th className="text-center" colSpan="3">Numerasi</th>                                  
                    </tr>
                    <tr>
                        <th className="text-center">Rata2</th>
                        <th className="text-center">Tertinggi</th>
                        <th className="text-center">Terendah</th>
                        <th className="text-center">Rata2</th>
                        <th className="text-center">Tertinggi</th>
                        <th className="text-center">Terendah</th>
                    </tr>
                    
                </thead>
                {this.tbody()}
            </table>
        )
    }
}

export default TblKonversiSkor;